import React, { useMemo } from 'react';
import { LockIcon } from 'lucide-react';
import { MetricCard } from '../components/MetricCard';
import { PageHeader } from '../components/PageHeader';
import { Card, SectionTitle } from '../components/ui/Card';
import { currentUser } from '../data/user';
import { useLocale } from '../contexts/LocaleContext';
import { useProgress } from '../contexts/ProgressContext';
import { average, buildHistory } from '../utils/history';
import { isWeeklyReviewAvailable } from '../utils/progress';
export function WeeklyReview() {
  const {
    t
  } = useLocale();
  const progress = useProgress();
  const available = isWeeklyReviewAvailable();
  const history = useMemo(() => buildHistory(90, currentUser.streak), []);
  const week = useMemo(() => [...history, {
    date: new Date(),
    score: progress.todayScore
  }].slice(-7), [history, progress.todayScore]);
  const weekAverage = average(week);
  return <div className="px-2 pb-2" data-id="element-4084" data-mp="38ueacisfeqjd">
      <PageHeader title={t('stats.review.title')} subtitle={t('review.subtitle')} showBack data-id="element-4085" data-mp="38vpmb5w0z4lk" />

      {!available ? <Card className="p-2" data-id="element-4086" data-mp="1bmfwkz71d1ip">
          <p className="flex items-start gap-2 text-[13px] leading-snug text-deep" data-id="element-4087" data-mp="1bl4r8uxxzlph">
            <LockIcon size={15} className="mt-[2px] shrink-0 text-muted" aria-hidden="true" data-id="element-4088" data-mp="17jt2ssqt16iv" />
            {t('stats.review.locked')}
          </p>
          <p className="mt-2 text-[11.5px] leading-snug text-muted" data-id="element-4089" data-mp="12jern1twpggm">
            {t('review.lockedHint')}
          </p>
        </Card> : <>
          <Card tone="dark" className="rounded-panel p-3" data-id="element-4090" data-mp="1vb86opy8bvw8">
            <p className="bee-overline text-[9px] font-bold text-ondark" data-id="element-4091" data-mp="1qb3pexphyx4y">
              {t('stats.review.avg')}
            </p>
            <p className="mt-1 flex items-baseline gap-1" data-id="element-4092" data-mp="1lcsfyo346on9">
              <span className="bee-num text-[44px] font-bold leading-none text-sand" data-id="element-4093" data-mp="1led8y99s5zj0">
                {weekAverage}
              </span>
              <span className="bee-num text-[13px] font-medium text-ondark" data-id="element-4094" data-mp="9wkkt7q0iflm">/100</span>
            </p>
            <p className="mt-1 text-[12.5px] leading-snug text-ondark" data-id="element-4095" data-mp="bdre4lqfdk0d">
              {t('review.avgHint')}
            </p>
          </Card>

          <div className="mt-2 grid grid-cols-2 gap-2" data-id="element-4096" data-mp="gcaxqfhjqjpk">
            <MetricCard label={t('stats.review.strong')} value={t('stats.category.movement')} hint={t('review.strongHint')} accent data-id="element-4097" data-mp="2e481mmr3q0z" />
            <MetricCard label={t('stats.review.weak')} value={t('stats.category.sleep')} hint={t('review.weakHint')} data-id="element-4098" data-mp="3osnl9fzzoz5v" />
          </div>

          <Card className="mt-2 p-2" data-id="element-4099" data-mp="3fsr37x83uyjs">
            <SectionTitle data-id="element-4100" data-mp="3ftsi6cs8s56s">{t('stats.review.tip')}</SectionTitle>
            <p className="text-[13.5px] leading-relaxed text-deep" data-id="element-4101" data-mp="3jt1arebjpx0r">
              {t('stats.review.tipBody')}
            </p>
            <p className="mt-2 text-[11px] leading-snug text-muted" data-id="element-4102" data-mp="35vcs8d4yb1yv">
              {t('review.tipNote')}
            </p>
          </Card>
        </>}
    </div>;
}